import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
var CANVAS_2D_CONTEXT_TYPE = '2d';
var CANVAS_ELEMENT_NAME = 'canvas';
var DATA_URL_TYPE = 'image/png';
export default function tryCreateDataURIFromImage(imgElement) {
    try {
        var canvas = document.createElement(CANVAS_ELEMENT_NAME);
        // First try to use the natural width and height of the image.
        var width = imgElement.naturalWidth;
        var height = imgElement.naturalHeight;
        if (!(width > 0 && height > 0)) {
            // If either natural dimension is 0, use the normal dimensions and log this occurrence.
            logUsage(datapoints.CreateDataURIMissingNaturalDimensions.datapoint.name);
            width = imgElement.width;
            height = imgElement.height;
        }
        if (width > 0 && height > 0) {
            canvas.width = width;
            canvas.height = height;
            canvas.getContext(CANVAS_2D_CONTEXT_TYPE).drawImage(imgElement, 0, 0);
            return canvas.toDataURL(DATA_URL_TYPE);
        }
    }
    catch (ex) {
        // Just assume the operation is not successful and a null will be retured in the end
    }
    return null;
}
//# sourceMappingURL=tryCreateDataURIFromImage.js.map